import type { fastCleanGroupsStart } from '../userQuotaCleaner.actions';
import type { QuotaCleanerState } from '../userQuotaCleaner.types';

export const fastCleanGroupsStartReducer = (state: QuotaCleanerState, action: ReturnType<typeof fastCleanGroupsStart>) => ({
    ...state,
    fastCleanState: {
        ...state.fastCleanState,
        fastCleanGroups: state.fastCleanState.fastCleanGroups.map((group) => {
            if (action.payload.includes(group.groupId)) {
                return {
                    ...group,
                    cleaningState: {
                        isCleanLoading: true,
                        isCleanLoaded: false,
                        isCleanSuccess: false,
                        isCleanError: false,
                    },
                };
            }

            return group;
        }),
    },
});
